import { SxProps, Theme } from "@mui/material/styles";
import { couleurPrimaire } from "../../../../theme";
const styles: SxProps<Theme> = [
  {
    padding: "32px",
    margin: "auto",
    maxWidth: 1080,
    width: "fit-content",
    border: "2px solid " + couleurPrimaire,
    textAlign: "center",
    "& li": {
      display: "block",
    },
    "& h4": {
      mb: "4px",
    },
    "& p": {
      fontWeight: 600,
      lineHeight: 1.6,
    },
    "& span": {
      fontSize: 16,
    },
    "& .infoText": {
      textAlign: "left",
      margin: "auto",
      padding: "0 16px 4px 16px",
      "& h2": {
        marginTop: 0,
      },
    },
    "& .infoTextLargeRed": {
      fontSize: "large",
      color: "rgb(195,0,0)",
      margin: "0",
    },
    "& .infoTextRed": {
      color: "rgb(195,0,0)",
      margin: "0",
    },
    "& .infoTextGreen": {
      color: "#7F9D00",
      margin: "0",
    },
    "& .infoTextDefault": {
      margin: "0",
      textAlign: "center",
    },
    "& .infoTextDefaultWithImg": {
      margin: "0",
      display: "inline-block",
    },
    "& .img": {
      width: "22px",
      height: "22px",
      margin: "0px 2px 0px 2px",
    },
  },
];
export default styles;
